module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "halftitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST TO")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IME")])]), _vm._v(" "), _c('p', {
    staticClass: "halftitle2"
  }, [_vm._v("UNFORGETTABLE STORIES THAT HISTORY FORGOT")]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "jpg",
      "src": "Images/Art_Pxii_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef04c930","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/halftitle1.vue
// module id = 81
// module chunks = 0